import * as React from "react";

const Ending = () => {
    return (
      <ol className="references">
        <li>
          Fauci AS, Lane HC. Four decades of HIV/AIDS — much accomplished, much to do. <em>N Engl J Med.</em> 2020;383(1):1-4.
        </li>
        <li>
        The White House Office of National AIDS Policy. <em>National HIV/AIDS Strategy for the United States 2022–2025.</em> Washington, DC. Published 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.whitehouse.gov/wp-content/uploads/2021/11/National-HIV-AIDS-Strategy.pdf">
          https://www.whitehouse.gov/wp-content/uploads/2021/11/National-HIV-AIDS-Strategy.pdf
          </a>
        </li>
        <li>
        Office of Infectious Disease and HIV/AIDS Policy, HHS. Overview: what is Ending the HIV Epidemic in the U.S.? Updated June 2, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/overview">
            https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/overview
          </a>
        </li>
        <li>
        The White House Office of National AIDS Policy. National HIV/AIDS Strategy (2022-2025). Updated December 14, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/national-hiv-aids-strategy/national-hiv-aids-strategy-2022-2025">
          https://www.hiv.gov/federal-response/national-hiv-aids-strategy/national-hiv-aids-strategy-2022-2025
          </a>
        </li>
        <li>
        HIV.gov. Ending the HIV Epidemic: A Plan for America. Flashcard. February 2020. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.cdc.gov/endhiv/docs/ending-HIV-epidemic-overview-508.pdf">
            https://www.cdc.gov/endhiv/docs/ending-HIV-epidemic-overview-508.pdf
          </a>
        </li>
        <li>
        Dawson L, Kates J. The U.S. Ending the HIV Epidemic (EHE) Initiative: what you need to know. Published February 9, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none" />
          <a target="_blank" className="underline" href="https://www.kff.org/hivaids/issue-brief/the-u-s-ending-the-hiv-epidemic-ehe-initiative-what-you-need-to-know/">
            https://www.kff.org/hivaids/issue-brief/the-u-s-ending-the-hiv-epidemic-ehe-initiative-what-you-need-to-know/
          </a>
        </li>
        <li>
        Office of Infectious Disease and HIV/AIDS Policy, HHS. Key strategies in the plan. Updated May 8, 2020. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/key-strategies">
            https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/key-strategies
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. CDC fact sheet: HIV in the United States and Dependent Areas. July 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf">
            https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf
          </a>
        </li>
        <li>
        Li Z, Purcell DW, Sansom SL, Hayes D, Hall HI. Vital signs: HIV transmission along the continuum of care—United States, 2016. <em>MMWR Morb Mortal Wkly Rep.</em> 2019;68(11):262-272.
        </li>
        <li>
        HIV.gov. U.S. Statistics. Updated June 2, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/hiv-basics/overview/data-and-trends/statistics">
            https://www.hiv.gov/hiv-basics/overview/data-and-trends/statistics
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. HIV pre-exposure prophylaxis (PrEP) care system. Reviewed March 18, 2022. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none" />
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/effective-interventions/prevent/prep/index.html">
            https://www.cdc.gov/hiv/effective-interventions/prevent/prep/index.html
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. Monitoring selected national HIV prevention and care objectives by using HIV surveillance data: United States and 6 dependent areas, 2019. Published May 2021. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-26-no-2/content/national-profile.html">
            https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-26-no-2/content/national-profile.html
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. HIV cluster and outbreak detection and response. Reviewed March 2, 2022. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none" />
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/programresources/guidance/cluster-outbreak/index.html">
            https://www.cdc.gov/hiv/programresources/guidance/cluster-outbreak/index.html
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. HIV treatment. Reviewed May 20, 2021. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html">
            https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html 
          </a>
        </li>
        <li>
        Office of Infectious Disease and HIV/AIDS Policy, HHS. Ready, Set, PrEP. Updated March 18, 2022. Accessed April 15, 2022.  
          <br />
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/prep-program">
          https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/prep-program
          </a>
        </li>
        <li>
        Office of Infectious Disease and HIV/AIDS Policy, HHS. Ready, Set, PrEP pharmacies. Updated November 12, 2020. Accessed April 15, 2022.  
          <br />
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/prep-pharmacies">
            https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/prep-pharmacies
          </a>
        </li>
        <li>
        HIV.gov. Mail order now an option for Ready, Set, PrEP. Published January 25, 2021. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.hiv.gov/blog/mail-order-now-option-ready-set-prep">
            https://www.hiv.gov/blog/mail-order-now-option-ready-set-prep
          </a>
        </li>
       
        <li>
        US Department of Health & Human Services. About Dashboard | AHEAD. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://ahead.hiv.gov/about">
          https://ahead.hiv.gov/about
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. Ending the HIV epidemic in the U.S. (EHE): local Ending the HIV Epidemic in the U.S. plans. Reviewed July 27, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.cdc.gov/endhiv/action/local-ehe-plans.html">
            https://www.cdc.gov/endhiv/action/local-ehe-plans.html
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. Ending the HIV epidemic in the U.S. (EHE): EHE in action. Reviewed April 1, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.cdc.gov/endhiv/action/jumpstart.html">
            https://www.cdc.gov/endhiv/action/jumpstart.html
          </a>
        </li>
        <li>
        Office of Infectious Disease and HIV/AIDS Policy, HHS. Ending the HIV Epidemic funding. Updated April 5, 2022. Accessed April 15, 2022.&nbsp;
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/funding">
            https://www.hiv.gov/federal-response/ending-the-hiv-epidemic/funding
          </a>
        </li>
        <li>
        The White House Office of Management and Budget. <em>Budget of the U.S. Government: Fiscal Year 2023</em>. Washington, DC. Published 2022. Accessed May 6, 2022.&nbsp;
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.whitehouse.gov/wp-content/uploads/2022/03/budget_fy2023.pdf">
          https://www.whitehouse.gov/wp-content/uploads/2022/03/budget_fy2023.pdf
          </a>
        </li>
        <li>
          Office of Infectious Disease and HIV/AIDS Policy, HHS. Prior national HIV/AIDS strategies (2010-2021). Updated December 1, 2021. Accessed April 15, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/federal-response/national-hiv-aids-strategy/national-hiv-aids-strategies-2010-2021">
            https://www.hiv.gov/federal-response/national-hiv-aids-strategy/national-hiv-aids-strategies-2010-2021
          </a>
        </li>


        <li>
        AIDS.gov. A timeline of HIV/AIDS. Accessed May 2, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.hiv.gov/sites/default/files/aidsgov-timeline.pdf">
          https://www.hiv.gov/sites/default/files/aidsgov-timeline.pdf
          </a>
        </li>
        <li>
        Kaiser Family Foundation. The HIV/AIDS epidemic in the US: the basics. Published June 7, 2021. Accessed May 2, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/">
          https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/
          </a>
        </li>
        <li>
        Centers for Disease Control and Prevention. Issue brief: HIV and transgender communities. Reviewed April 22, 2022. Accessed May 2, 2022.&nbsp; 
          <br className="d-block d-md-none"/>
          <a target="_blank" className="underline" href="https://www.cdc.gov/hiv/pdf/policies/data/cdc-hiv-policy-issue-brief-transgender.pdf">
          https://www.cdc.gov/hiv/pdf/policies/data/cdc-hiv-policy-issue-brief-transgender.pdf
          </a>
        </li>
        
        
        <li>
        Moitra E, Tao J, Olsen J, et al. Impact of the COVID-19 pandemic on HIV testing rates across four geographically diverse urban centres in the United States: an observational study. <em>Lancet Reg Health Am.</em> 2022;7:100159. doi:10.1016/j.lana.2021.100159
        </li>
        <li>
        Huang YLA, Zhu W, Wiener J, Kourtis AP, Hall HI, Hoover KW. Impact of coronavirus disease 2019 (COVID-19) on human immunodeficiency virus (HIV) pre-exposure prophylaxis prescriptions in the United States—a time-series analysis. <em>Clin Infect Dis.</em> 2022;ciac038. doi:10.1093/cid/ciac038
        </li>
        <li>
        C-SPAN. National Institutes of Health fiscal year 2022 budget request. Published May 25, 2021. Accessed April 15, 2022. 
          <br />
          <a target="_blank" className="underline" href="https://www.c-span.org/video/?512007-1/national-institutes-health-fiscal-year-2022-budget-request">
            https://www.c-span.org/video/?512007-1/national-institutes-health-fiscal-year-2022-budget-request
          </a>
        </li>
      </ol>
    )
  }

export default Ending;